import React, { useEffect, useState } from 'react';
import { EDUGATE_API_URL } from '../config/serviceConfig';

function CasCallback() {
  const [status, setStatus] = useState('正在验证登录...');
  
  useEffect(() => {
    // 获取URL中的ticket参数
    const params = new URLSearchParams(window.location.search);
    const ticket = params.get('ticket');
    
    if (!ticket) {
      setStatus('未提供有效票据');
      setTimeout(() => window.location.href = '/', 2000);
      return;
    }
    
    // 发送票据到EduGate验证（使用统一配置）
    const apiUrl = `${EDUGATE_API_URL}/api/cas-callback?ticket=${ticket}`;
    
    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          // 认证成功
          setStatus('登录成功，正在跳转...');
          
          // 保存用户信息
          localStorage.setItem('userInfo', JSON.stringify({
            username: data.data.studentNumber,
            name: data.data.name,
            class_name: data.data.className,
            isSchoolUser: true,
            isCasUser: true,
            openFlowDialog: true // 登录后打开流程选择对话框的标志
          }));
          
          // 延时跳转到首页
          setTimeout(() => window.location.href = '/', 1000);
        } else {
          // 认证失败
          setStatus(`登录失败: ${data.message}`);
          setTimeout(() => window.location.href = '/', 2000);
        }
      })
      .catch(error => {
        console.error('验证过程出错:', error);
        setStatus('验证过程出错，请重试');
        setTimeout(() => window.location.href = '/', 2000);
      });
  }, []);
  
  return (
    <div className="cas-callback-container">
      <div className="cas-callback-box">
        <h2>{status}</h2>
        <div className="loading-spinner"></div>
      </div>
      
      <style jsx>{`
        .cas-callback-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          background-color: #f5f5f5;
        }
        .cas-callback-box {
          background: white;
          padding: 30px;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          text-align: center;
        }
        .loading-spinner {
          display: inline-block;
          width: 50px;
          height: 50px;
          border: 3px solid rgba(0, 0, 0, 0.1);
          border-radius: 50%;
          border-top-color: #0066cc;
          animation: spin 1s ease-in-out infinite;
          margin-top: 20px;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default CasCallback; 